import React, { useState, useEffect } from 'react';
import EventsList from '../components/Events/EventsList';
import { API_ENDPOINTS } from '../config/apiConfig';
import { Link } from 'react-router-dom';
import { Product } from '../components/ProductCard/ProductCard';

const CalendrierPage: React.FC = () => {
   

  return (
    <>
      <div className="product-grid" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
        <p>Balade tout les jours de 8h à 20h</p>
        
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Link to="/prise-rdv" className="btn btn-primary">
            Prendre un rendez-vous
          </Link>
        </div>
      </div>
      <EventsList />
    </>
  );
};

export default CalendrierPage;